import * as React from 'react';
import type { SVGProps } from 'react';

export const RoofIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M26 7.7V1H22V5L16 1L1 11V31H3.3L16 22.2L28.7 31H31V11L26 7.7ZM17 4.1L29 12.1V24.6L17.1 16.4H17V4.1ZM3 12.1L15 4.1V16.3H14.9L3 24.6V12.1ZM29 28.8L16 19.8L3 28.8V27L16 18L29 27V28.8Z"
      fill="currentColor"
    />
  </svg>
);
